import { ButtonsGroupOption } from "@bps/fluent-ui";
import { AuthenticationMethods } from "@libs/api/gateways/plt/plt-gateway.dtos";

export const mfaMethodsOptions: ButtonsGroupOption<AuthenticationMethods>[] = [
  {
    key: AuthenticationMethods.Phone,
    text: "SMS/Mobile"
  },
  {
    key: AuthenticationMethods.AlternateEmail,
    text: "Email"
  },
  {
    key: AuthenticationMethods.Totp,
    text: "TOTP (Authenticator)"
  }
];

// eslint-disable-next-line const-case/uppercase
export const MFA_METHODS_OPTIONS_MAP = {
  [AuthenticationMethods.Phone]: "SMS/Mobile",
  [AuthenticationMethods.AlternateEmail]: "Email",
  [AuthenticationMethods.Totp]: "OTP (Authenticator)"
};

export const mfaCountOptions = [
  { key: 0, text: "None" },
  { key: 1, text: "One" },
  { key: 2, text: "Two" }
];
